import { MedicalReviewReport } from '../../medical-review/models/medical-review-report.model';

export class CustomerIndividualMedicalCondition {
    public id: number;
    public customerNumberId: number;
    public customerIndividualMedicalConditionTypeId: number;
    public lastEpisodeDate: Date;
    public occurrenceDate: Date;
    public isAdaptiveEquipment: boolean;
    public effectiveDate: Date;
    public endDate;
    public durationTypeId: number;
    public durationValue: string;
    public isMVDMonitoring: boolean;
    public customerIndividualMedicalConditionTypeDisplayValue: string;
    public durationTypeDisplayValue: string;
    public reports: MedicalReviewReport[];
    public nextReportDueOn: Date;
}
